export const keyMap = {
  "buttons": {
    "correct": "A",
    "pass": "S",
    "wrong": "D",
    "undo": "Q",
    "kill": "P",
    "showQuestion": "K",
    "showAnswer": "M",
  },
  "timer": {
    "startTimer": "Z",
  },
  "image": {
    "imageZoom": "I"
  }
}